import { useState, useEffect } from 'react';
import Router from './routes/router';
import { Provider as ReduxProvider } from 'react-redux';
import store from './store';
import './styles/global.css';
import Toaster from 'components/common/toaster';
import SideModal from 'components/sidemodal';
import Modal from 'components/popup';
import FileViewer from 'components/common/file-viewes.tsx';
import AppContextProvider from 'context/app-context';
import LanguageContextProvider from 'context/language-context';
import { requestForToken } from 'firebase-config';

const App = () => {
  // const [language, setLanguage] = useState<string | undefined>(getLanguage());
  // const [loading, setLoading] = useState<boolean>(false);
  // const localUser = getItemFromLocalStorage('user');
  // const userRole = localUser?.role_details?.role_data?.name;
  // const { i18n } = useTranslation();
  // const onLanguageChange = (lang?: string) => {
  //   i18n.changeLanguage(lang);
  //   setLanguage(lang);
  // };
  // const hasPermission = (access: string) => {
  //   return access === userRole ? true : false;
  // };
  // const hasMultiplePermission = (accessList: string[]) => {
  //   return !accessList || (accessList.length > 0 && accessList.find(role => role === userRole))
  //     ? true
  //     : false;
  // };
  // const setLoader = (isLoading: boolean) => {
  //   setLoading(isLoading);
  // };

  useEffect(() => {
    requestForToken();
  }, []);

  return (
    <LanguageContextProvider>
      <ReduxProvider store={store}>
        <AppContextProvider>
          <Router />
          <Toaster />
          <SideModal />
          <Modal />
          <FileViewer />
        </AppContextProvider>
      </ReduxProvider>
    </LanguageContextProvider>
  );
};

export default App;
